var $1397b38c000e3e4b$exports = {};
$1397b38c000e3e4b$exports = {
    "collectionLabel": `Suggesties`
};


export {$1397b38c000e3e4b$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
